import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

import {
  IOrganization,
  IOrganizationDetails,
  IRegion,
  IULB,
} from '../common-model';
import { GlobalService } from '../global.service';

@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.scss'],
})
export class OrganizationComponent implements OnInit {
  regionList: IOrganization[] = [];
  corporationList: IOrganization[] = [];
  smartcorporationList: IOrganization[] = [];
  municipalityList: IULB[] = [];
  ulbList: IULB[] = [];

  @Output() orgChange = new EventEmitter<IRegion>();
  @Input() OrgTypeID: number = 0;
  @Input() ulbId: number = 0;
  @Input() orgId: number = 0;
  //@Input() Smartflag: number = 0;
  Smartflag: number = 2;
  selectedCorporationID: number = 0;
  selectedCorporationName: string = 'Corporation';
  selectedMunicipalityID: number = 0;
  selectedMunicipalityName: string = 'Region';
  selectedULBId: number = 0;
  selectedULBName: string = 'Municipality';
  showUlb: boolean = false;
  Dutyid:number = 0;
  OrganizationTypeID:number = 0;
  OrganizationID:number = 0;
  OrganizationName:string = '';
  RegionID:number = 0;
  RegionName:string = '';

  constructor(private commonService: GlobalService) {}

  ngOnInit(): void {
    //this.OrgTypeID = this.orgId;
    this.OrganizationName = String(sessionStorage.getItem('OrganizationName'));
    this.Dutyid = Number(sessionStorage.getItem('Dutyid'));
    this.OrganizationTypeID = Number(sessionStorage.getItem('OrganizationTypeID'));
    this.OrganizationID = Number(sessionStorage.getItem('OrganizationID'));
    this.RegionID = Number(sessionStorage.getItem('RegionID'));
    this.RegionName = String(sessionStorage.getItem('RegionName'));
    
   if (sessionStorage.getItem('organizationList') === null) 
    {
        this.commonService.getSchemeWiseDetails().subscribe(() => {
            let session = sessionStorage.getItem('organizationList');
              session = session !== null ? JSON.parse(session) : null;
            let orgList: IOrganizationDetails =
              session as unknown as IOrganizationDetails;
            this.regionList = orgList.regionDetail;
            this.corporationList = orgList.corporationDetail.filter(corp=>!corp.SmartCity);
            this.smartcorporationList = orgList.corporationDetail.filter(corp=>corp.SmartCity);
            this.municipalityList = orgList.municipalityDetail;
        });
    } 
    else 
    {
        let session = sessionStorage.getItem('organizationList');
            session = session !== null ? JSON.parse(session) : null;
        let orgList: IOrganizationDetails =
            session as unknown as IOrganizationDetails;
        this.regionList = orgList.regionDetail;
        this.corporationList = orgList.corporationDetail.filter(corp=>!corp.SmartCity);
        this.smartcorporationList = orgList.corporationDetail.filter(corp=>corp.SmartCity);
        this.municipalityList = orgList.municipalityDetail;
    }

    if (this.Dutyid > 0 ) 
    {
       if (this.OrganizationTypeID == 6)
       {
          this.setCorporation(this.OrganizationID, this.OrganizationName, this.OrganizationTypeID,2) 
       }
       else if (this.OrganizationTypeID == 8)
       {
          this.setCorporation(this.OrganizationID, this.RegionName, this.OrganizationTypeID,2) 
          this.setULB(this.OrganizationID,this.OrganizationName) 
       }
    }

  }

  setactivebutton(selectedOrgTypeId: number) {
    this.OrgTypeID = selectedOrgTypeId;
    this.showUlb = false;
    if (selectedOrgTypeId === 0) {
        this.selectedMunicipalityID = 0;
        this.selectedMunicipalityName = 'Region';
        this.selectedCorporationID = 2;
        this.selectedCorporationName = 'Corporation';
        this.selectedULBId = 0;
        this.selectedULBName = 'Municipality';
    }
    sessionStorage.setItem('SelectedCorp', "Overall");
    sessionStorage.setItem('SelectedReg', "Overall");
    sessionStorage.setItem('SelectedMunicip', "Overall");

    this.orgChange.emit({
      orgTypeId: selectedOrgTypeId,
      regionId: 0,
      ulbId: 0,
      Smartflag: 2
    });
  }



  setCorporation(regionId: number, regionName: string, OrgType: number, Smartflag:number) {

    this.showUlb = false;
    this.selectedULBId = 0;
    this.selectedULBName = 'Overall Municipality';
    if (Smartflag === 0 )
    {
      //this.smartcity(Smartflag);
       sessionStorage.setItem('SelectedCorp', "");
       sessionStorage.setItem('SelectedReg', "");
       sessionStorage.setItem('SelectedMunicip', "");
      this.selectedCorporationName = regionName;
    }
    else if (Smartflag === 1 )
    {
       //this.smartcity(Smartflag);
       sessionStorage.setItem('SelectedCorp', "");
       sessionStorage.setItem('SelectedReg', "");
       sessionStorage.setItem('SelectedMunicip', "");
        this.selectedCorporationName = regionName;
    }
    else if (Smartflag === 2 )
    {
      //this.selectedCorporationName = "Overall Corporation";
      if (OrgType === 6) {
        this.selectedMunicipalityID = 0;
        this.selectedMunicipalityName = 'Region';
        this.selectedCorporationID = regionId;
        this.selectedCorporationName = regionName;
        this.OrgTypeID = OrgType;
        //this.Smartfl//ag = Smartflag;
        sessionStorage.setItem('SelectedCorp', regionName);
        sessionStorage.setItem('SelectedReg', "");
        sessionStorage.setItem('SelectedMunicip', "");
      }else {
        this.selectedCorporationID = 0;
        this.selectedCorporationName = 'Corporation';
        this.selectedMunicipalityID = regionId;
        this.selectedMunicipalityName = regionName;
        this.OrgTypeID = OrgType;
        sessionStorage.setItem('SelectedCorp', "");
        sessionStorage.setItem('SelectedReg', regionName);
        sessionStorage.setItem('SelectedMunicip', "Overall Municipality");
        //this.Smartflag = Smartflag;
        if (regionId !== 0) {
          this.showUlb = true;
          this.loadUlb(regionId);
        } else {
          this.showUlb = false;
        }
      }
      //this.smartcity(Smartflag);
    }

    this.orgChange.emit({ orgTypeId: OrgType, regionId: regionId, ulbId: 0,Smartflag:Smartflag });
  }

  // smartcity(isSmartcity:number)
  // {
  //   this.orgChange.emit({
  //     orgTypeId: this.OrgTypeID,
  //     regionId: this.selectedMunicipalityID,
  //     ulbId: this.selectedULBId,
  //     Smartflag: isSmartcity,
      
  //   });

  // }

  loadUlb(regionId: number) {
    const myClonedArray = Object.assign([], this.municipalityList);
    
    this.ulbList = myClonedArray.filter((data: IULB) => {
      return data.RegionID === regionId;
    });
    this.ulbList.unshift({
      RegionID: 0,
      MuncipalityName: 'Overall Municipality',
      MunicipalityID: 0,
    });
  }

  setULB(ulbId: number, ulbName: string) {
    this.selectedULBId = ulbId;
    this.selectedULBName = ulbName;
    sessionStorage.setItem('SelectedMunicip', ulbName);
    sessionStorage.setItem('SelectedCorp', "");


    this.orgChange.emit({
      orgTypeId: this.OrgTypeID,
      regionId: this.selectedMunicipalityID,
      ulbId: this.selectedULBId,
      Smartflag: 2,
    });
  }
}
